(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alternative-faq"] && !Shopify.designMode) return;
  try {
    

  const accordionBtns = document.querySelectorAll(".accordion");

						accordionBtns.forEach((accordion) => {
						  accordion.onclick = function () {
						    if(this.classList.contains("is-open")) {
                              this.classList.toggle("is-open");
                               this.parentElement.classList.toggle('show');
                              let content = this.nextElementSibling;
                              content.style.maxHeight = null;
                              return;
                            }
                            let prevAccordion = document.querySelector(".accordion.is-open");
						    if(prevAccordion) {
						       prevAccordion.nextElementSibling.style.maxHeight = null;
						       prevAccordion.classList.toggle("is-open"); 
                               prevAccordion.parentElement.classList.toggle("show"); 
						    }

						    this.classList.toggle("is-open");
                            this.parentElement.classList.toggle('show');

						    let content = this.nextElementSibling;
						    console.log(content);

						    if (content.style.maxHeight) {
						      //this is if the accordion is open
						      content.style.maxHeight = null;
						    } else {
						      //if the accordion is currently closed
						      content.style.maxHeight = content.scrollHeight + "px";
						      console.log(content.style.maxHeight);
						    }
						  };
						});
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  const accordionBtns = document.querySelectorAll(".accordion");

						accordionBtns.forEach((accordion) => {
						  accordion.onclick = function () {
						    if(this.classList.contains("is-open")) {
                              this.classList.toggle("is-open");
                              let content = this.nextElementSibling;
                              content.style.maxHeight = null;
                              return;
                            }
                            let prevAccordion = document.querySelector(".accordion.is-open");
						    if(prevAccordion) {
						       prevAccordion.nextElementSibling.style.maxHeight = null;
						       prevAccordion.classList.toggle("is-open"); 
						    }

						    this.classList.toggle("is-open");

						    let content = this.nextElementSibling;
                             console.log(content);

						    if (content.style.maxHeight) {
						      //this is if the accordion is open
    						      content.style.maxHeight = null;
                               let content_none = this.style.display = "none";
						    } else {
						      //if the accordion is currently closed
						      content.style.maxHeight = content.scrollHeight + "px";
                              
						      console.log(content.style.maxHeight);
						    }
						  };
						});

       




 $(window).scroll(function() {
	var $height = $(window).scrollTop();
	 var $iHeight = $(".slideshow").height();
    if($height > $iHeight) {
		$('.header').addClass('is-sticky');
	} else {
		$('.header').removeClass('is-sticky');
	}
     	
});
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    

const accordionBtns = document.querySelectorAll(".accordion");

						accordionBtns.forEach((accordion) => {
						  accordion.onclick = function () {
						    if(this.classList.contains("is-open")) {
                              this.classList.toggle("is-open");
                             
                              let content = this.nextElementSibling;
                              content.style.maxHeight = null;
                              return;
                            }
                            let prevAccordion = document.querySelector(".accordion.is-open");
						    if(prevAccordion) {
						       prevAccordion.nextElementSibling.style.maxHeight = null;
						       prevAccordion.classList.toggle("is-open"); 
						      
						    }

						    this.classList.toggle("is-open");
                            

						    let content = this.nextElementSibling;
						    console.log(content);

						    if (content.style.maxHeight) {
						      //this is if the accordion is open
						      content.style.maxHeight = null;
						    } else {
						      //if the accordion is currently closed
						      content.style.maxHeight = content.scrollHeight + "px";
						      console.log(content.style.maxHeight);
						    }
						  };
						});


    
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-ingredients"] && !Shopify.designMode) return;
  try {
    

const accordionBtns = document.querySelectorAll(".accordion");

						accordionBtns.forEach((accordion) => {
						  accordion.onclick = function () {
						    if(this.classList.contains("is-open")) {
                              this.classList.toggle("is-open");
                              this.parentElement.classList.toggle('show');
                              let content = this.nextElementSibling;
                              content.style.maxHeight = null;
                              return;
                            }
                            let prevAccordion = document.querySelector(".accordion.is-open");
						    if(prevAccordion) {
						       prevAccordion.nextElementSibling.style.maxHeight = null;
						       prevAccordion.classList.toggle("is-open"); 
						       prevAccordion.parentElement.classList.toggle("show"); 
						    }

						    this.classList.toggle("is-open");
                            this.parentElement.classList.toggle('show');

						    let content = this.nextElementSibling;
						    console.log(content);

						    if (content.style.maxHeight) {
						      //this is if the accordion is open
						      content.style.maxHeight = null;
						    } else {
						      //if the accordion is currently closed
						      content.style.maxHeight = content.scrollHeight + "px";
						      console.log(content.style.maxHeight);
						    }
						  };
						});


    
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    

const accordionBtns = document.querySelectorAll(".accordion");

						accordionBtns.forEach((accordion) => {
						  accordion.onclick = function () {
						    if(this.classList.contains("is-open")) {
                              this.classList.toggle("is-open");
                             
                              let content = this.nextElementSibling;
                              content.style.maxHeight = null;
                              return;
                            }
                            let prevAccordion = document.querySelector(".accordion.is-open");
						    if(prevAccordion) {
						       prevAccordion.nextElementSibling.style.maxHeight = null;
						       prevAccordion.classList.toggle("is-open"); 
						      
						    }

						    this.classList.toggle("is-open");
                            

						    let content = this.nextElementSibling;
						    console.log(content);

						    if (content.style.maxHeight) {
						      //this is if the accordion is open
						      content.style.maxHeight = null;
						    } else {
						      //if the accordion is currently closed
						      content.style.maxHeight = content.scrollHeight + "px";
						      console.log(content.style.maxHeight);
						    }
						  };
						});


    
  

  } catch(e) { console.error(e); }
})();
})();
